import script from "./PartTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./PartTwo.vue?vue&type=script&setup=true&lang=js"

import "./PartTwo.vue?vue&type=style&index=0&id=2ea74923&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea74923"]])

export default __exports__